import { prefixCmsUrl } from '@/lib/prefixCmsUrl';
import { CmsImageData } from '@/services/cms/models/CmsImageData';

export const focusPointBgStyles = (image?: CmsImageData) => {
    const bgUrl = image?.link;
    const focusPointX = image?.focusPoint?.percentageX;
    const focusPointY = image?.focusPoint?.percentageY;

    return {
        backgroundImage: bgUrl ? `url(${prefixCmsUrl(bgUrl)})` : undefined,
        backgroundSize: 'cover',
        backgroundPosition: focusPointX && focusPointY ? `${focusPointX}% ${focusPointY}%` : '50% 50%',
    };
};
